"use client";
import { useCallback, useEffect, useState } from "react";
import { FBProductType } from "../data/passticket_type";

export default function SearchInput(props: { initValue: string, datas: Array<FBProductType>, childParent: Function }) {
  const [search, setSearch] = useState(props.initValue);

  const handleChange = useCallback((e: any) => {
    setSearch(e.target.value);
  }, [search]);

  useEffect(() => {
    getResponse();
  }, [search]);

  const getResponse = async () => {
    try {
      props.childParent(search);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <label className="relative block mt-3 mb-3">
      <span className="sr-only">Search</span>
      <span className="absolute inset-y-0 left-1 flex items-center pl-2">
        <svg className="mt-1 h-5 w-5 fill-slate-300" viewBox="0 0 20 20">
          <path d="M11.8153 10.3439C12.6061 9.2673 13.0732 7.9382 13.0732 6.5C13.0732 2.91015 10.163 0 6.57318 0C2.98333 0 0.0731812 2.91015 0.0731812 6.5C0.0731812 10.0899 2.98333 13 6.57318 13C8.01176 13 9.3412 12.5327 10.4179 11.7415L10.4171 11.7422C10.4466 11.7822 10.4794 11.8204 10.5156 11.8566L14.3661 15.7071C14.7566 16.0976 15.3898 16.0976 15.7803 15.7071C16.1708 15.3166 16.1708 14.6834 15.7803 14.2929L11.9298 10.4424C11.8936 10.4062 11.8553 10.3734 11.8153 10.3439ZM12.0732 6.5C12.0732 9.53757 9.61075 12 6.57318 12C3.53561 12 1.07318 9.53757 1.07318 6.5C1.07318 3.46243 3.53561 1 6.57318 1C9.61075 1 12.0732 3.46243 12.0732 6.5Z" fill="black"></path>
        </svg>
      </span>
      <input className="placeholder:italic placeholder:text-slate-400 block bg-white w-full border border-slate-300 rounded-xl py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" placeholder="한글 또는 영어로 검색" type="text" name="search" value={search} onChange={handleChange} />
    </label>
  );
}